import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { Element } from 'src/Libs/shop/models'

import PowerMeterSystemConfigurationItemCard from './PowerMeterSystemConfigurationItemCard'
import { PowerMeterLimits } from 'src/Libs/shop/types'

interface PowerMeterSystemConfigurationCardProps {
  powerMeters: Element[]
}

const PowerMeterSystemConfigurationCard: React.FC<PowerMeterSystemConfigurationCardProps> = ({ powerMeters }) => {
  const { t } = useCustomTranslation()

  return (
    <Stack>
      {powerMeters && powerMeters.length > 1 && (
        <Typography variant="h5" mt={2}>
          {t('shop.system-configure-card.power-meter')}
        </Typography>
      )}
      {powerMeters &&
        powerMeters.map(powerMeter => {
          let highestId = '0'
          powerMeters.forEach(pm => {
            const currentId = pm.extensions.e3dcData.customFields.powerMeterId ?? ''
            const match = currentId.match(/\d+/)
            const numericId = match ? parseInt(match[0]) : 0
            const maxId = Number(PowerMeterLimits.ExternalSourceMaxId)
            if (numericId > parseInt(highestId) && numericId <= maxId) {
              highestId = currentId
            }
          })
          return <PowerMeterSystemConfigurationItemCard key={powerMeter.id} powerMeterData={powerMeter} powerMeterHighestId={highestId} />
        })}
    </Stack>
  )
}

export default PowerMeterSystemConfigurationCard
